import { currentUser } from '@adornis/users/client/currentUser.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { fromEvent, merge, Subject } from 'rxjs';

export const extendSession = new Subject<Date>();

const SESSION_TIMEOUT_MS = 1000 * 60 * 30;
const SESSION_TIMEOUT_CHECK_MS = 1000 * 60;
const SESSION_ACTIVITY_KEY = 'portal:last-activity';
const SESSION_CHANNEL_NAME = 'portal:session-activity';

const activityChannel =
  typeof BroadcastChannel === 'undefined' ? undefined : new BroadcastChannel(SESSION_CHANNEL_NAME);

function getLastActivity() {
  const value = localStorage.getItem(SESSION_ACTIVITY_KEY);

  if (!value) return Date.now();

  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) ? parsedValue : Date.now();
}

function setLastActivity(timestamp: number) {
  localStorage.setItem(SESSION_ACTIVITY_KEY, String(timestamp));
}

function markActivity(timestamp = Date.now()) {
  setLastActivity(timestamp);
  activityChannel?.postMessage({ type: 'activity', timestamp });
}

function initializeLastActivity() {
  const value = localStorage.getItem(SESSION_ACTIVITY_KEY);

  if (value) return;

  setLastActivity(Date.now());
}

async function checkSessionTimeout() {
  if (Date.now() - getLastActivity() < SESSION_TIMEOUT_MS) return;

  // the page stays and shows its login screen, so after logging in again the user is back where they left off
  if (await currentUser().result) await logout();
}

export function sessionExtend() {
  extendSession.next(new Date());
}

export function initSessionTimeout() {
  initializeLastActivity();
  window.setInterval(() => void checkSessionTimeout(), SESSION_TIMEOUT_CHECK_MS);

  // auto logout after 30 mins of inactivity
  merge(fromEvent(window, 'mousemove'), fromEvent(window, 'keydown'), extendSession).subscribe(_ => {
    markActivity();
  });

  activityChannel?.addEventListener('message', event => {
    if (event.data?.type === 'activity' && typeof event.data.timestamp === 'number') {
      setLastActivity(event.data.timestamp);
    }
  });
}
